import login from './login';

export default {
  language: 'nl',
  country: 'nl',
  name: 'Nederlands',
  embeddedLocale: login,
};
